/* eslint-disable camelcase */
import { useMemo } from 'react';

interface Props {
  directProps?: any;
  source_page?: string;
  source_page_section?: string;
  section?: string;
  page_type?: string | 'modal';
  component_name?: string;
  index?: number;
  page_name?: string;
  button_type?: string;
  button_name?: string;
  button_copy?: any;
  component_detail?: string | number;
  component_id?: string | number;
  value?: string | number;
  link_type?: string;
  link_name?: string;
  link_copy?: string;
  form_email?: string;
}

const useMemoizedProps = ({
  directProps = {},
  source_page,
  source_page_section,
  section,
  page_type,
  component_name,
  index,
  page_name,
  button_type,
  button_name,
  button_copy,
  component_detail,
  component_id,
  value,
  link_type,
  link_name,
  link_copy,
  form_email,
}: Props) => {
  const props = useMemo(() => {
    const conditionalProps = {
      source_page,
      source_page_section,
      section,
      page_type,
      component_name,
      index,
      page_name,
      button_type,
      button_name,
      button_copy,
      component_detail,
      component_id,
      value,
      link_type,
      link_name,
      link_copy,
      form_email,
    };

    const filteredConditionalProps = Object.fromEntries(
      Object.entries(conditionalProps).filter(([, v]) => v !== undefined)
    );
    return {
      ...directProps,
      ...filteredConditionalProps,
    };
  }, [
    source_page,
    source_page_section,
    section,
    page_type,
    component_name,
    index,
    page_name,
    button_type,
    button_name,
    button_copy,
    component_detail,
    component_id,
    value,
    link_type,
    link_name,
    link_copy,
    form_email,
    directProps,
  ]);

  return props;
};

export default useMemoizedProps;
